import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "tag-cloud-preview" };
const _hoisted_2 = { class: "more-tag" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'TagCloudPreview',
    props: {
        tags: {}
    },
    setup(__props) {
        /**
         * 标签云预览组件
         * 在首页侧边栏展示热门标签
         */
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                        key: tag.name,
                        to: `/tag/${tag.name}`,
                        class: "tag-item"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]));
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, { to: "/tags" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode("查看全部 →", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
